var _defs, _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    id: "OBJECT",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b2b2b2;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30,10.25,21.75,2A3.34,3.34,0,0,0,17,2L11.23,7.77a1,1,0,0,0-.29.6l-.79,7.1L1.29,24.33A1,1,0,0,0,1,25v5a1,1,0,0,0,1,1H7a1,1,0,0,0,.7-.29l1.66-1.66a1,1,0,0,0,.28-.85l-.22-1.57,1.57.22a1,1,0,0,0,.85-.28l4.72-4.72,7.1-.79a1,1,0,0,0,.6-.29L30,15A3.34,3.34,0,0,0,30,10.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.29,30.71A1,1,0,0,0,2,31H7a1,1,0,0,0,.7-.29l1.66-1.66a1,1,0,0,0,.28-.85l-.22-1.57,1.57.22a1,1,0,0,0,.85-.28l4.7-4.7-6.38-6.38L1.29,24.33A1,1,0,0,0,1,25v5A1,1,0,0,0,1.29,30.71Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20.8,
    cy: 11.2,
    r: 3.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.4f88519596e16e293145559661719784.svg";
export { ForwardRef as ReactComponent };